import React from "react";
import Tooltip from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import { tooltipClasses } from "@mui/material/Tooltip";
import GetAppIcon from "@material-ui/icons/GetApp";
import { Button } from "@material-ui/core";
import { usePPTXExport } from "./usePPTXExport";

const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: "15rem",
    fontSize: "1rem",
    color: "black",
    textAlign: "center",
    background: "white",
    border: "0.5px solid lightgrey",
  },
});

function RegionalSalesReviewPackagePPTX({
  dashboardTitle = "Regional Sales Review Package",
  fileName = "Regional_Sales_Review_Package",
  currentQuarter,
  currentWeekNumber,
  inline = false,
}) {
  const { loading, tooltipText, handleExport } = usePPTXExport({
    dashboardTitle,
    fileName,
    currentQuarter,
    currentWeekNumber,
  });

  if (inline) {
    return (
      <div style={{ display: "flex", alignItems: "center", position: "relative" }}>
        <CustomWidthTooltip title={tooltipText} placement="left">
          <button
            onClick={handleExport}
            disabled={loading}
            style={{
              border: "none",
              background: "transparent",
              cursor: loading ? "default" : "pointer",
              position: "relative",
              opacity: loading ? 0.5 : 1,
            }}
          >
            <GetAppIcon style={{ width: "20px", height: "20px", marginRight: "3px", color: "#808080", fill: "#A9A9A9" }} />
            {loading && (
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 2,
                }}
              >
                <img src="/test_loading.gif" alt="Loading..." style={{ width: "20px", height: "20px" }} />
              </div>
            )}
          </button>
        </CustomWidthTooltip>
      </div>
    );
  }

  return (
    <CustomWidthTooltip title={tooltipText} placement="left">
      <Button
        onClick={handleExport}
        disabled={loading}
        variant="contained"
        color="primary"
        startIcon={loading ? null : <GetAppIcon />}
        style={{
          margin: "1rem",
          position: "fixed",
          top: "80px",
          right: "20px",
          zIndex: 1000,
          minWidth: "120px",
        }}
      >
        {loading ? "Exporting..." : "Export PPTX"}
      </Button>
    </CustomWidthTooltip>
  );
}

export default RegionalSalesReviewPackagePPTX;
